import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';

export const Wrapper = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.border.secondary};
  display: flex;
  color: ${({ theme }) => theme.text.primary};
  flex-direction: row;
  font-size: ${formatViewport(16)};
  font-weight: 300;
  gap: ${formatViewport(8)};
  justify-content: space-between;
  padding: ${formatViewport(7.5)} 0;
  width: 100%;
`;

export const Status = styled.div<{ $open: boolean }>`
  color: ${({ theme, $open }) => ($open ? theme.colors.green : theme.colors.red)};
  font-size: ${formatViewport(16)};
  font-weight: 300;
`;
